import Typography from '@alltrails/core/components/Typography';
import LinksColumn from '@alltrails/seo/components/LinksColumn';
import styles from './DesktopLinkSection.module.scss';

type DesktopLinkSectionProps = {
  title: string;
  links: { label: string; href: string }[];
  seoTestAddTrailsToLocationLinks?: boolean;
  seoTestAddHikingTrailsToLocationLinks?: boolean;
};

const DesktopLinkSection = ({ title, links, seoTestAddTrailsToLocationLinks, seoTestAddHikingTrailsToLocationLinks }: DesktopLinkSectionProps) => {
  const firstBatch = links.slice(0, 8);
  const secondBatch = links.slice(8, 15);

  return (
    <div>
      <Typography variant="heading200" component="h3" mt="0" className={styles.title}>
        {title}
      </Typography>
      <div className={styles.linkBlockColumns}>
        <div className={styles.linksColumn}>
          <LinksColumn
            links={firstBatch}
            seoTestAddTrailsToLocationLinks={seoTestAddTrailsToLocationLinks}
            seoTestAddHikingTrailsToLocationLinks={seoTestAddHikingTrailsToLocationLinks}
          />
        </div>
        {!!secondBatch.length && (
          <div className={styles.linksColumn}>
            <LinksColumn
              links={secondBatch}
              seoTestAddTrailsToLocationLinks={seoTestAddTrailsToLocationLinks}
              seoTestAddHikingTrailsToLocationLinks={seoTestAddHikingTrailsToLocationLinks}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DesktopLinkSection;
